import { render } from "./WActionDialog.vue?vue&type=template&id=61fa7e72&ts=true"
import script from "./WActionDialog.vue?vue&type=script&lang=ts"
export * from "./WActionDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__